/* Glawhaus · Landing de ventas
   1. Héroe: el arco se dibuja, el punto se enciende y la cámara cruza la puerta.
   2. Partículas y brillo que siguen al cursor o al dedo.
   3. Filtro de categorías con chips tipo cápsula.
   4. Agregar al carrito (punto volador) y Comprar ya (borde que se dibuja).
   Sin dependencias. Si algo falla, la página sigue completa y usable. */
(function () {
  "use strict";
  // Cada sección de la landing carga este archivo; solo debe correr una vez,
  // o "Agregar al carrito" agregaría el producto dos veces.
  if (window.__ghLanding) return;
  window.__ghLanding = true;

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var clamp = function (v, a, b) { return v < a ? a : v > b ? b : v; };
  // Rampa suave 0..1 entre a y b
  var ramp = function (a, b, v) { var t = clamp((v - a) / (b - a), 0, 1); return t * t * (3 - 2 * t); };
  var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var routes = (window.Glawhaus && window.Glawhaus.routes) || {};
  var CART_ADD = routes.cartAdd ? routes.cartAdd + ".js" : "/cart/add.js";
  var CART = routes.cart || "/cart";

  /* ================================================================ HÉROE */
  var hero = $("[data-gh-hero]");
  if (hero) initHero(hero);

  function initHero(hero) {
    var stage = $(".gh-hero__stage", hero);
    var svg = $(".gh-hero__logo", hero);
    var wrap = $(".gh-hero__logo-wrap", hero);
    var scene = $(".gh-hero__scene", hero);
    var settle = $("[data-gh-settle]", hero);
    var canvas = $("[data-gh-particles]", hero);
    var beats = $$("[data-gh-beat]", hero).map(function (el) {
      return { el: el, a: parseFloat(el.getAttribute("data-from")), b: parseFloat(el.getAttribute("data-to")), o: -1 };
    });
    var arc = $("[data-gh-arc]", svg), sweep = $("[data-gh-sweep-path]", svg);
    var glow = $("[data-gh-glow]", svg), glowXL = $("[data-gh-glow-xl]", svg);
    var dot = $("[data-gh-dot]", svg), dotGlow = $("[data-gh-dot-glow]", svg);
    var halo = $("[data-gh-halo]", svg), glintPath = $("[data-gh-glint-path]", svg);
    var sweepGrad = $("[data-gh-sweep]", svg), glintGrad = $("[data-gh-glint]", svg);

    var mobile = window.matchMedia("(max-width: 749px)").matches;
    var last = {};
    function put(key, el, fn, v, eps) {
      if (last[key] !== undefined && Math.abs(last[key] - v) < (eps || 0.002)) return;
      last[key] = v; fn(el, v);
    }
    var setAttr = function (name) { return function (el, v) { el && el.setAttribute(name, v.toFixed(4)); }; };
    var setVar = function (name) { return function (el, v) { el && el.style.setProperty(name, v.toFixed(4)); }; };

    /* Estado visual para un progreso p en [0,1] */
    function paint(p, now) {
      var draw = ramp(0.10, 0.42, p);            // el arco se dibuja
      var lit = ramp(0.18, 0.62, p);             // cuánto brilla todo
      var ignite = ramp(0.40, 0.58, p);          // el punto se enciende
      var z = reduce ? 0 : ramp(0.62, 0.93, p);  // cruzar la puerta
      var zoom = Math.exp(Math.log(34) * z * z * (1.4 - 0.4 * z));
      var through = ramp(0.86, 0.97, p);         // del otro lado

      put("arc", arc, setAttr("stroke-dashoffset"), 1 - draw);
      put("sweep", sweep, setAttr("stroke-dashoffset"), 1 - draw);
      // Un trazo de largo cero con punta redondeada se ve como un punto suelto:
      // los trazos que se dibujan quedan invisibles hasta que empiezan a crecer.
      var cap = clamp(draw * 40, 0, 1);
      put("arcO", arc, setAttr("opacity"), cap, 0.01);
      put("sweepO", sweep, setAttr("opacity"), cap, 0.01);
      put("glow", glow, setAttr("opacity"), lit * 0.85 * (1 - z));
      put("glowXL", glowXL, setAttr("opacity"), lit * 0.7 * (1 - z));
      put("glowXLd", glowXL, setAttr("stroke-dashoffset"), 1 - draw);
      put("glowd", glow, setAttr("stroke-dashoffset"), 1 - draw);
      put("dotS", dot, function (el, v) { el.style.transform = "scale(" + v.toFixed(4) + ")"; }, 0.62 + 0.38 * ignite);
      put("dotG", dotGlow, setAttr("opacity"), ignite * (1 - z * 0.6));
      put("halo", halo, setAttr("opacity"), ignite * (1 - ramp(0.64, 0.74, p)));
      // Barrido de luz que cruza el arco en diagonal
      var sx = -26 + 116 * ramp(0.16, 0.56, p);
      put("sweepT", sweepGrad, function (el, v) { el.setAttribute("gradientTransform", "translate(" + v.toFixed(2) + "," + (v * -0.55).toFixed(2) + ")"); }, sx, 0.05);
      put("zoom", wrap, setVar("--gh-zoom"), zoom, 0.0008);
      // Al salir de la luz el aura se apaga casi del todo, para que el final del
      // héroe tenga el mismo crema que la tienda y no se note el corte de color.
      put("aura", stage, setVar("--gh-aura"), (0.35 + 0.65 * lit) * (1 - 0.8 * through), 0.004);
      put("auraS", stage, setVar("--gh-aura-s"), 0.92 + 0.28 * lit + 1.4 * z, 0.004);
      put("scene", stage, setVar("--gh-scene"), 1 - through, 0.004);
      put("guide", hero, setVar("--gh-guide"), 1 - ramp(0.56, 0.66, p), 0.01);
      put("sg", hero, setVar("--gh-sg"), 1 - clamp(p / 0.85, 0, 1), 0.004);
      wrap.style.willChange = z > 0.001 && z < 0.999 ? "transform" : "auto";

      // Con movimiento reducido el héroe es estático: los textos quedan todos visibles
      if (reduce) return lit;

      // Textos: cada beat entra y sale dentro de su rango
      for (var i = 0; i < beats.length; i++) {
        var bt = beats[i], t = (p - bt.a) / (bt.b - bt.a), o;
        if (t < 0 || t > 1) o = bt.a === 0 && t < 0 ? 1 : 0;
        else o = Math.min(bt.a === 0 ? 1 : ramp(0, 0.24, t), bt.b >= 1 ? 1 : 1 - ramp(0.76, 1, t));
        if (Math.abs(o - bt.o) > 0.003) {
          bt.o = o;
          bt.el.style.opacity = o.toFixed(3);
          bt.el.style.transform = "translate3d(0," + ((1 - o) * 14).toFixed(1) + "px,0)";
          bt.el.setAttribute("aria-hidden", o < 0.5 ? "true" : "false");
        }
      }
      if (settle) {
        var so = ramp(0.88, 0.97, p);
        if (Math.abs(so - (last.settle || -1)) > 0.003) {
          last.settle = so;
          settle.style.opacity = so.toFixed(3);
          settle.classList.toggle("is-on", so > 0.02);
          settle.setAttribute("aria-hidden", so < 0.5 ? "true" : "false");
        }
      }
      return lit;
    }

    /* ---------------------------------------------- brillo que sigue al puntero */
    var ptr = { x: 32, y: 20, tx: 32, ty: 20, active: 0, seen: 0 };
    function onPointer(cx, cy) {
      var r = svg.getBoundingClientRect();
      if (!r.width) return;
      ptr.tx = clamp((cx - r.left) / r.width * 64, 4, 60);
      ptr.ty = clamp((cy - r.top) / r.height * 64, 4, 60);
      ptr.seen = performance.now();
      wake();
    }
    window.addEventListener("pointermove", function (e) { onPointer(e.clientX, e.clientY); }, { passive: true });
    window.addEventListener("touchmove", function (e) {
      if (e.touches[0]) onPointer(e.touches[0].clientX, e.touches[0].clientY);
    }, { passive: true });

    /* ------------------------------------------------------------ partículas */
    var ctx = canvas && canvas.getContext ? canvas.getContext("2d") : null;
    var parts = [], W = 0, H = 0, DPR = 1, sprites = {};
    function sprite(rgb) {
      var c = document.createElement("canvas"), s = 64; c.width = c.height = s;
      var g = c.getContext("2d"), gr = g.createRadialGradient(s / 2, s / 2, 0, s / 2, s / 2, s / 2);
      gr.addColorStop(0, "rgba(" + rgb + ",1)"); gr.addColorStop(0.35, "rgba(" + rgb + ",.55)");
      gr.addColorStop(1, "rgba(" + rgb + ",0)");
      g.fillStyle = gr; g.fillRect(0, 0, s, s); return c;
    }
    function sizeCanvas() {
      if (!ctx) return;
      DPR = Math.min(window.devicePixelRatio || 1, 1.5);
      W = stage.clientWidth; H = stage.clientHeight;
      canvas.width = Math.round(W * DPR); canvas.height = Math.round(H * DPR);
      ctx.setTransform(DPR, 0, 0, DPR, 0, 0);
    }
    if (ctx) {
      sprites.oro = sprite("200,161,101"); sprites.rosa = sprite("232,196,184"); sprites.luz = sprite("255,246,228");
      var n = reduce ? 0 : mobile ? 40 : 90;
      for (var i = 0; i < n; i++) {
        parts.push({
          x: Math.random(), y: Math.random(),
          vx: (Math.random() - 0.5) * 0.00006, vy: -0.00002 - Math.random() * 0.00007,
          r: 2 + Math.random() * (mobile ? 5 : 7), a: 0.25 + Math.random() * 0.6,
          k: Math.random() < 0.5 ? "oro" : Math.random() < 0.7 ? "rosa" : "luz",
          ph: Math.random() * 6.28
        });
      }
      sizeCanvas();
    }
    function drawParticles(dt, lit, zoomPhase, now) {
      if (!ctx || !parts.length) return;
      ctx.clearRect(0, 0, W, H);
      var cx = 0.5, cy = 0.56;
      var px = ptr.active > 0.05 ? (ptr.x / 64) : -1, py = ptr.y / 64;
      for (var i = 0; i < parts.length; i++) {
        var q = parts[i];
        q.x += q.vx * dt; q.y += q.vy * dt;
        // se inclinan hacia el brillo
        if (px >= 0) { q.x += (px - q.x) * 0.00012 * dt * ptr.active; q.y += (py - q.y) * 0.00008 * dt * ptr.active; }
        // al cruzar la puerta salen disparadas hacia afuera
        if (zoomPhase > 0) { var dx = q.x - cx, dy = q.y - cy; q.x += dx * 0.004 * zoomPhase * dt / 16; q.y += dy * 0.004 * zoomPhase * dt / 16; }
        if (q.y < -0.05) { q.y = 1.05; q.x = Math.random(); }
        if (q.y > 1.08 || q.x < -0.08 || q.x > 1.08) {
          if (zoomPhase > 0.02) { q.x = cx + (Math.random() - 0.5) * 0.08; q.y = cy + (Math.random() - 0.5) * 0.08; }
          else { q.x = Math.random(); q.y = 1.02; }
        }
        var tw = 0.75 + 0.25 * Math.sin(now * 0.0012 + q.ph);
        var alpha = q.a * tw * (0.22 + 0.78 * lit) * (1 - zoomPhase * 0.35);
        if (alpha < 0.01) continue;
        var s = q.r * (1 + zoomPhase * 1.6);
        ctx.globalAlpha = alpha;
        ctx.drawImage(sprites[q.k], q.x * W - s, q.y * H - s, s * 2, s * 2);
      }
      ctx.globalAlpha = 1;
    }

    /* ------------------------------------------------------------ el bucle */
    var top = 0, height = 1, vh = window.innerHeight, heroVisible = true;
    function measure() {
      var r = hero.getBoundingClientRect();
      top = r.top + window.scrollY; height = hero.offsetHeight; vh = window.innerHeight;
      sizeCanvas();
    }
    function target() {
      var span = Math.max(1, height - vh);
      return clamp((window.scrollY - top) / span, 0, 1);
    }

    var cur = reduce ? 0.6 : target(), raf = 0, prev = 0;
    function frame(now) {
      raf = 0;
      var dt = prev ? Math.min(64, now - prev) : 16; prev = now;
      var tp = reduce ? 0.6 : target();
      cur += (tp - cur) * (1 - Math.exp(-dt / 90));
      if (Math.abs(tp - cur) < 0.0004) cur = tp;

      // brillo: sigue al puntero, o gira solo si nadie lo mueve
      var idle = now - ptr.seen > 2600;
      ptr.active += ((idle ? 0 : 1) - ptr.active) * 0.06;
      if (idle) {
        var ang = now * 0.00045;
        ptr.tx = 32 + Math.cos(ang) * 17; ptr.ty = 26 + Math.sin(ang) * 17;
      }
      ptr.x += (ptr.tx - ptr.x) * 0.12; ptr.y += (ptr.ty - ptr.y) * 0.12;

      var lit = paint(cur, now);
      var draw = ramp(0.10, 0.42, cur);
      if (glintGrad) {
        put("gx", glintGrad, setAttr("cx"), ptr.x, 0.05);
        put("gy", glintGrad, setAttr("cy"), ptr.y, 0.05);
      }
      put("glint", glintPath, setAttr("opacity"), draw * (0.55 + 0.45 * ptr.active) * (1 - ramp(0.62, 0.72, cur)), 0.01);

      drawParticles(dt, lit, ramp(0.62, 0.9, cur), now);

      // Sigue vivo mientras el héroe se vea (partículas y brillo en reposo)
      if (heroVisible && !document.hidden) raf = requestAnimationFrame(frame);
      else prev = 0;
    }
    function wake() { if (!raf && heroVisible) { raf = requestAnimationFrame(frame); } }

    if ("IntersectionObserver" in window) {
      new IntersectionObserver(function (en) {
        heroVisible = en[0].isIntersecting;
        if (heroVisible) wake();
      }).observe(hero);
    }
    window.addEventListener("scroll", wake, { passive: true });
    window.addEventListener("resize", function () { measure(); wake(); });
    window.addEventListener("load", function () { measure(); wake(); });
    document.addEventListener("visibilitychange", function () { if (!document.hidden) wake(); });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { measure(); wake(); });

    // arranque: el logo empieza apagado (el HTML trae el estado encendido por si no hay JS)
    measure();
    paint(cur, performance.now());
    hero.classList.add("is-ready");
    wake();
  }

  /* ==================================================== CHIPS DE CATEGORÍA */
  $$("[data-gh-shop]").forEach(function (shop) {
    var chips = $$("[data-gh-chip]", shop);
    var cards = $$("[data-gh-card]", shop);
    var grid = $("[data-gh-grid]", shop);
    var status = $("[data-gh-status]", shop);
    chips.forEach(function (chip) {
      chip.addEventListener("click", function () {
        var cat = chip.getAttribute("data-gh-chip");
        chips.forEach(function (c) { c.setAttribute("aria-pressed", c === chip ? "true" : "false"); });
        var shown = 0;
        cards.forEach(function (card) {
          var match = cat === "todo" || card.getAttribute("data-cat") === cat;
          if (match) shown++;
          if (reduce) { card.hidden = !match; return; }
          if (match && card.hidden) {
            card.hidden = false; card.classList.add("is-leaving");
            requestAnimationFrame(function () { requestAnimationFrame(function () { card.classList.remove("is-leaving"); }); });
          } else if (!match && !card.hidden) {
            card.classList.add("is-leaving");
            setTimeout(function () { if (card.classList.contains("is-leaving")) { card.hidden = true; card.classList.remove("is-leaving"); } }, 230);
          }
        });
        if (status) status.textContent = shown + (shown === 1 ? " producto" : " productos");
        // si la grilla quedó arriba de la pantalla, volvemos a su inicio
        if (grid) {
          var r = grid.getBoundingClientRect();
          if (r.top < 0) window.scrollTo({ top: window.scrollY + r.top - 150, behavior: reduce ? "auto" : "smooth" });
        }
      });
    });
  });

  /* ============================================================== CARRITO */
  var toastEl;
  function toast(msg) {
    if (!toastEl) { toastEl = document.createElement("div"); toastEl.className = "gh-toast"; toastEl.setAttribute("role", "status"); document.body.appendChild(toastEl); }
    toastEl.textContent = msg; toastEl.classList.add("is-on");
    clearTimeout(toast.t); toast.t = setTimeout(function () { toastEl.classList.remove("is-on"); }, 3200);
  }

  function refreshCart() {
    return fetch(CART + ".js", { credentials: "same-origin" }).then(function (r) { return r.json(); }).then(function (cart) {
      $$("[data-cart-count]").forEach(function (el) { el.textContent = cart.item_count; el.hidden = cart.item_count === 0; });
      return fetch(CART + "?section_id=cart-drawer-content", { credentials: "same-origin" })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var fresh = new DOMParser().parseFromString(html, "text/html").querySelector("[data-cart-drawer-inner]");
          var target = document.querySelector("#cart-drawer [data-cart-drawer-inner]");
          if (fresh && target) target.innerHTML = fresh.innerHTML;
        });
    }).catch(function () {});
  }

  // El punto del logo sale del botón y vuela al carrito
  function flyToCart(fromEl) {
    var cartBtn = document.querySelector('.header [data-drawer-open="cart-drawer"]') || document.querySelector('[data-drawer-open="cart-drawer"]');
    if (!cartBtn || reduce || !fromEl.animate) { if (cartBtn) bump(cartBtn); return; }
    var a = fromEl.getBoundingClientRect(), b = cartBtn.getBoundingClientRect();
    var x0 = a.left + a.width / 2, y0 = a.top + a.height / 2, x1 = b.left + b.width / 2, y1 = b.top + b.height / 2;
    var mx = (x0 + x1) / 2, my = Math.min(y0, y1) - 120;
    var d = document.createElement("span"); d.className = "gh-fly"; document.body.appendChild(d);
    var steps = [], N = 18;
    for (var i = 0; i <= N; i++) {
      var t = i / N, u = 1 - t;
      var x = u * u * x0 + 2 * u * t * mx + t * t * x1, y = u * u * y0 + 2 * u * t * my + t * t * y1;
      steps.push({ transform: "translate(" + x + "px," + y + "px) scale(" + (1 - t * 0.45) + ")", opacity: t > 0.9 ? (1 - t) * 10 : 1 });
    }
    d.animate(steps, { duration: 720, easing: "cubic-bezier(.45,0,.2,1)" }).onfinish = function () { d.remove(); bump(cartBtn); };
  }
  function bump(el) { el.classList.remove("gh-bump"); void el.offsetWidth; el.classList.add("gh-bump"); }

  document.addEventListener("submit", function (e) {
    var form = e.target.closest("[data-gh-add-form]");
    if (!form) return;
    e.preventDefault();
    var btn = $("[data-gh-add]", form);
    var id = $('[name="id"]', form).value;
    if (!btn || btn.getAttribute("aria-disabled") === "true") return;
    var label = btn.innerHTML;
    btn.setAttribute("aria-disabled", "true");
    fetch(CART_ADD, {
      method: "POST", credentials: "same-origin",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    }).then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.d.description || res.d.message || "No se pudo agregar");
        flyToCart(btn);
        btn.innerHTML = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m5 12.5 4.5 4.5L19 7.5"/></svg> Agregado';
        refreshCart();
        setTimeout(function () { btn.innerHTML = label; btn.removeAttribute("aria-disabled"); }, 1800);
      })
      .catch(function (err) { btn.innerHTML = label; btn.removeAttribute("aria-disabled"); toast(err.message); });
  });

  // Comprar ya: el borde se dibuja y te lleva al pago con solo ese producto
  document.addEventListener("click", function (e) {
    var buy = e.target.closest("[data-gh-buy]");
    if (!buy || e.metaKey || e.ctrlKey || e.shiftKey) return;
    e.preventDefault();
    if (buy.classList.contains("is-going")) return;
    buy.classList.add("is-going");
    var txt = $("[data-gh-buy-label]", buy);
    if (txt) txt.textContent = "Vamos al pago…";
    setTimeout(function () { window.location.href = buy.href; }, reduce ? 0 : 650);
  });
  // Si el visitante vuelve con el botón atrás, el botón vuelve a su estado normal
  window.addEventListener("pageshow", function () {
    $$("[data-gh-buy].is-going").forEach(function (b) {
      b.classList.remove("is-going");
      var txt = $("[data-gh-buy-label]", b); if (txt) txt.textContent = "Comprar ya";
    });
  });

  /* ================================================ arco del cierre al verse */
  var close = $("[data-gh-close]");
  if (close && "IntersectionObserver" in window) {
    var io = new IntersectionObserver(function (en) {
      if (en[0].isIntersecting) { close.classList.add("is-in"); io.disconnect(); }
    }, { threshold: 0.35 });
    io.observe(close);
  } else if (close) close.classList.add("is-in");
})();
